import React, { useEffect } from 'react';
import { Trophy } from 'lucide-react';
import CloseButton from './ui/CloseButton';

const PURPLE_GRADIENT = 'linear-gradient(145deg,#7c3aed,#5b21b6)';

// Shows the outcome of a "Generate Competition Quiz" run in its own modal.
const CompetitionResultModal = ({ result, onClose }) => {
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, []);

    if (!result) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '1rem',
        }}>
            <div style={{
                backgroundColor: '#ffffff', borderRadius: '0.9rem',
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.3)', width: '90%', maxWidth: 'min(520px, 96vw)',
                display: 'flex', flexDirection: 'column', overflow: 'hidden',
            }}>
                <div style={{ background: PURPLE_GRADIENT, color: '#fff', padding: '1.1rem 1.25rem', position: 'relative' }}>
                    <CloseButton onClick={onClose} />
                    <h2 style={{ fontSize: '1.25rem', fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <Trophy style={{ width: '1.2rem', height: '1.2rem' }} /> Competition Test Created
                    </h2>
                </div>
                <div style={{ padding: '1.25rem' }}>
                    <p className="mb-0">
                        Created <strong>{result.title}</strong> (#{result.quiz_id}) as an <strong>unpublished</strong> competition.
                        Publish it from Test Management to open the window.
                    </p>
                </div>
                <div style={{ borderTop: '1px solid #e5e7eb', padding: '0.85rem 1.25rem', display: 'flex', justifyContent: 'flex-end' }}>
                    <button className="btn btn-primary" onClick={onClose}>Done</button>
                </div>
            </div>
        </div>
    );
};

export default CompetitionResultModal;
